'use client';

import { AbsoluteSpinner } from '../../../../_components/AbsoluteSpinner';
import { useCommonAuthProvider } from '../../providers/CommonAuthProvider/CommonAuthProvider';
import { getUTMs } from '@utils/utm';
import { Auth0 } from 'app/_modules/auth/components/Auth0/Auth0';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { Route } from 'next';
import { useRouter } from 'next/navigation';
import React, { useEffect } from 'react';

export const SignUpPage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const { cloudAwsMarketplaceEnabled } = useFlags();
  const utms = getUTMs();
  const { isAuthenticated, isLoading } = useCommonAuthProvider();
  const { push } = useRouter();

  const marketPlaceAuthParams = cloudAwsMarketplaceEnabled
    ? {
      marketplace_customer_id: params.get('aws_customer_id') || '',
      marketplace_product_id: params.get('product_id') || '',
      marketplace_type: 'aws',
    }
    : { marketplace_customer_id: '',
      marketplace_product_id: '',
      marketplace_type: '' };

  const loginFlowInfo = {
    code: params.get('code'),
    tenantId: params.get('tenantId'),
    loginHint: params.get('login_hint'),
    connection: params.get('connection') ?? undefined,
  };

  const hasInvite = (loginFlowInfo.code && loginFlowInfo.tenantId && loginFlowInfo.loginHint);
  const invitePage = hasInvite
    ? `/invite?code=${loginFlowInfo.code}&tenantId=${loginFlowInfo.tenantId}&login_hint=${encodeURIComponent(loginFlowInfo.loginHint as string)}`
    : undefined;

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    if (invitePage) {
      push(invitePage as Route);

      return;
    }

    push('/');
  }, [invitePage, isAuthenticated]);

  if (isLoading || isAuthenticated) {
    return <AbsoluteSpinner />;
  }

  return (
    <Auth0
      appState={{
        returnTo: invitePage,
      }}
      authorizationParams={{
        screen_hint: 'signup',
        connection: hasInvite ? loginFlowInfo.connection : undefined,
        login_hint: hasInvite ? loginFlowInfo.loginHint as string : undefined,
        customQueryParams: marketPlaceAuthParams,
        ...utms,
      }}
    />
  );
};
